import { useQuery } from '@tanstack/react-query';
import type { AccountingDisplayTimezone } from '@pokerroom/types';
import { api } from '../lib/api';
import { sessionVenueKey, useAuthStore } from '../store/auth.store';

/** Permission fallback is presentation-only and is never stored as a venue setting. */
export function useAccountingDisplayTimezone(): string | undefined {
  const actor = useAuthStore((s) => s.user?.id);
  const token = useAuthStore((s) => s.accessToken);
  const revision = useAuthStore((s) => s.sessionRevision);
  const canRead = useAuthStore(
    (s) => !!s.user?.isSystemUser || s.allowedActions?.includes('accounting:read') === true,
  );
  const venue = sessionVenueKey(token);
  const query = useQuery({
    queryKey: ['accounting-display-timezone', actor, venue, revision, canRead],
    enabled: canRead && !!actor && !!token && !!venue,
    retry: false,
    queryFn: ({ signal }) =>
      api.get<AccountingDisplayTimezone>('/accounting/display-timezone', { signal }),
  });
  if (!canRead) return 'Asia/Taipei';
  // Loading, read failures, invalid zones and mismatched venue responses stay unavailable.
  return !query.isError && query.data?.venueId === venue ? query.data.displayTimezone : undefined;
}
